import AnimationClip from '../AnimationClip';
import Armature from '../../../Prototype/Armature';
import { fingerprintMissingDBArmature } from '../DBHelpers';
import { report } from '../../../report';
import {
    DragonbonesDefault,
    DragonbonesDefaultMeta,
} from './DragonbonesDefault';
import {
    AwaitIterators,
    ConcatIterators,
} from '../AnimationHelper';
import Renderable from '../../../Component/Renderable';
import { delay } from 'Utility/Task/TaskQueue';

interface DragonbonesFadeInMeta extends DragonbonesDefaultMeta {
    fadeInTime?: number;
    targetAlpha?: number;
    concat?: boolean;
    delay?: number;
}
export class DragonbonesFadeIn extends AnimationClip<DragonbonesFadeInMeta> {
    public *execute(
        gameObject: Armature,
        meta: DragonbonesFadeInMeta = {}
    ): IterableIterator<number> {
        const animDelay = meta.delay ?? 0;
        const armatureDisplay = gameObject.container;
        const renderable = gameObject.getComponent(Renderable);

        if (!armatureDisplay?.armature) {
            report('Unable to play DragonbonesFadeIn - missing armature', {
                once: true,
                sampleRate: 0.1,
                tags: {
                    gameObjectName: gameObject.name,
                },
                fingerprint: fingerprintMissingDBArmature,
            });
            return;
        }

        const { fadeInTime = 250, targetAlpha = 1, concat = true } = meta;
        const fadeTween = this.getTween(renderable).to(
            {
                alpha: targetAlpha
            },
            fadeInTime
        );

        yield* delay(animDelay);
        
        const iteratorFunc = concat ? ConcatIterators : AwaitIterators;

        yield* iteratorFunc([
            this.startTween(fadeTween),
            new DragonbonesDefault(gameObject, meta).execute(gameObject, meta,),
        ]);
    }
}
